import StripeSubscribe from './StripeSubscribe.component';

export default StripeSubscribe;